import React, { useState } from "react";
import { getAdminMaintenance, TableAndCountResponse } from "@api";
import { Box, Grid, Typography } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import withStyles from "@material-ui/core/styles/withStyles";
import MuiTableCell from "@material-ui/core/TableCell";
import { NavLink } from 'react-router-dom';
import { getSession, State } from "@store";
import { Route, Switch, useRouteMatch } from "react-router";
import { useDispatch } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Environments } from "./environment";
import { SystemTypes } from "./systemtype";

const TableCell = withStyles({
  root: {
    borderBottom: "none",
  },
})(MuiTableCell);

const adminPath = "/dashboard/admin/maintenance/";

export const Maintenance: React.FC = () => {
  const [isLoading, setIsloading] = useState<boolean>(true);

  const [maintenanceValues, setMaintenanceValues] = React.useState<
    TableAndCountResponse[]
  >([]);

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getSession());
    return () => {};
  }, [dispatch]);

  React.useEffect(() => {
    getAdminMaintenance()
      .then((data) => {
        setMaintenanceValues(data);
        setIsloading(false);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);
  return (
            <React.Fragment>
              <Box>
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography variant="h6">Maintenance</Typography>
                    <Table>
                      <TableBody>
                        {isLoading ? (
                          <CircularProgress size="1rem" />
                        ) : (
                             maintenanceValues.map((row) => (
                                <TableRow key={row.name}>
                                      <TableCell>
                                          <NavLink to={adminPath + row.id}>{row.name}</NavLink>                            
                                  </TableCell>
                                  <TableCell>{row.count}</TableCell>
                                </TableRow>
                            ))
                        )}
                      </TableBody>                                  
                      <Switch>                              
                        <Route exact path="/dashboard/admin/maintenance/environment">
                          <Environments />
                        </Route>
                        <Route exact path="/dashboard/admin/maintenance/business-unit">
                          <SystemTypes />
                        </Route>
                      </Switch>
                    </Table>
                  </Grid>
                </Grid>
              </Box>
            </React.Fragment>
        );
};
